import { render, staticRenderFns } from "./assistenza.vue?vue&type=template&id=7f0bcf76&scoped=true&"
import script from "./assistenza.vue?vue&type=script&lang=js&"
export * from "./assistenza.vue?vue&type=script&lang=js&"
import style0 from "./assistenza.vue?vue&type=style&index=0&id=7f0bcf76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0bcf76",
  null
  
)

export default component.exports